module.exports = __webpack_public_path__ + "static/media/Unterrichtsinhalte.e1857943.pdf";